import React, { Component } from 'react';
import { connect } from "react-redux";

import './weatherWidget.css';
import Carousel from '../carousel/carousel';

const clouds = require(`../../assets/weather/clouds.svg`);
const rainClouds = require(`../../assets/weather/rain_clouds.svg`);
const snow = require(`../../assets/weather/snow.svg`);
const sun = require(`../../assets/weather/sun.svg`);
const thunderstorm = require(`../../assets/weather/thunderstorm.svg`);

class WeatherWidget extends Component {
  constructor(props) { // active tab
    super(props);
    this.state = { active: 'weather' };
  }
  setActive = (activePage) => {
    this.setState({active: activePage})
  }
  render() {
    const { active } = this.state;
    const { temperature, condition, humidity } = this.props

    let weatherImage = sun;
    if(condition >= 200 && condition < 300){ weatherImage = thunderstorm;
    } else if(condition >= 300 && condition < 600){ weatherImage = rainClouds;
    } else if(condition >= 600 && condition < 800){ weatherImage = snow;
    } else if(condition > 800){ weatherImage = clouds; }

    return(
      <div className='widget carousel small'>
        <div className="flex small">
          <div className="weather-icon">
            <img src={weatherImage} width="100" height="100"/>
          </div>
          {this.renderCarousel(active) }

        </div>

        <Carousel items={['weather', 'humidity']} active={active} onClick={this.setActive} />
      </div>
    )
  }
  renderCarousel(active) {
    if(active === 'weather') {
      return (
        <div className="details">
          <div className="weather-details-header">Tomorrow</div>
          <p className="small">Outdoor temperature</p>
          <div className="number-big">{this.props.temperature}°C</div>
        </div>
      )
    } else {
      return (
        <div className="details">
          <div className="weather-details-header">Tomorrow</div>
          <p className="small">Humidity</p>
          <div className="number-big">{this.props.humidity}%</div>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    temperature: state.weather.temperature,
    condition: state.weather.condition,
    humidity: state.weather.humidity
  };
}

export default connect(mapStateToProps)(WeatherWidget);
